export const ROLES = {
  VIEWER: 'BACKOFFICE_VIEWER',
  EDITOR: 'BACKOFFICE_EDITOR',
  ADMIN: 'BACKOFFICE_ADMIN',
  ORCAMENTISTA: 'BACKOFFICE_ORCAMENTISTA',
  MEDALHAS: 'BACKOFFICE_MEDALHAS',
  TROFEUS: 'BACKOFFICE_TROFEUS',
  TOMBSTONES: 'BACKOFFICE_TOMBSTONES',
  PLACAS: 'BACKOFFICE_PLACAS',
  SDR: 'BACKOFFICE_SDR',
  MEDIA: 'BACKOFFICE_MEDIA',
  BLOGGER: 'BACKOFFICE_BLOGGER',
} as const;

// Backwards compatibility exports
export const viewerRole = ROLES.VIEWER;
export const editorRole = ROLES.EDITOR;
export const adminRole = ROLES.ADMIN;
export const orcamentistaRole = ROLES.ORCAMENTISTA;
export const medalhasRole = ROLES.MEDALHAS;
export const trofeusRole = ROLES.TROFEUS;
export const tombstonesRole = ROLES.TOMBSTONES;
export const placasRole = ROLES.PLACAS;
export const sdrRole = ROLES.SDR;
export const mediaRole = ROLES.MEDIA;
export const bloggerRole = ROLES.BLOGGER;
